'use es6';

import Application from 'MeetingsAdmin/app';
new Application().start();